import { useQuery } from '@tanstack/react-query';

import { FlightOperationNotificationClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightOperationNotificationClient = new FlightOperationNotificationClient(apiBaseUrl);

function useGetFlightOperationNotificationVersionGroups(id: number | null) {
  return useQuery({
    queryKey: [queryKeys.FlightOperationNotification.GetVersionGroups, { id }],
    queryFn: () => flightOperationNotificationClient.getVersionGroups(id),
  });
}

export default useGetFlightOperationNotificationVersionGroups;
